import { useMutation as U } from "react-query";
import { GoogleAnalytics as A } from "../../../../../../js/analytics/google/index.js";
import { UrlsAPI as i } from "../../../../../../js/urls/index.js";
import { useAuth as M } from "../../../../../features/auth/hooks/useAuth.js";
import { useEnvironment as R } from "../../../../../features/common/hooks/environment/useEnvironment.js";
import { ServiceMapNames as v, ServiceMapNamesBackend as y } from "../../../../../../common/shared/serviceType.js";
import { LANDING_QUERY_PARAM_KEYS as C, filterLandingParams as k } from "../../shared/landing-query-params.js";
import F from "../customization/useCustomization.js";
import { ShopSessionAPI as N } from "../../../../../../js/shop-session/index.js";
function E() {
  const {
    backendBaseUrl: m
  } = R(), {
    token: e
  } = M();
  return U(
    async (c) => await N.createShopSession(m, c, e)
  );
}
function q() {
  const { mutateAsync: m } = E(), {
    configuration: e,
    utmReferral: c
  } = F(), l = (r, t, s, n) => {
    const a = n ? void 0 : r.hour;
    return m({
      place: r.place ?? void 0,
      restaurant: t,
      addressExtra: r.addressInfo ?? "",
      service: {
        type: y[s],
        now: n,
        readyAt: a
      },
      querystring: k(window.location.search)
    });
  };
  return {
    saveSessionFromForm: l,
    getRestaurantUrl: async (r, t, s, n) => {
      const a = t.url[s];
      if (a === null)
        return null;
      const g = await l(r, t, s, n), u = new URL(a), h = i.getParamsFromUrl(u), S = i.getParamsFromUrl(new URL(window.location.href));
      let d = {
        ...Object.fromEntries(
          Object.entries(S).filter(([o]) => !C.has(o))
        ),
        ...h,
        shopSession: g.id
      };
      const f = e == null ? void 0 : e.settings.configuration.scope.find((o) => o.id === t.id), p = f == null ? void 0 : f.services[v[s]], P = (p == null ? void 0 : p.getMenuName()) ?? "";
      P.length && (d = {
        ...d,
        menu_name: P
      }), u.search = i.encodeParams(d);
      let w = await A.appendAnalyticsToUrl(u, c);
      if (window.CookiesManagement && window.CookiesManagement.isReady()) {
        const o = window.CookiesManagement.serialize();
        w = i.replaceParameters(w, o);
      }
      return w.toString();
    }
  };
}
export {
  E as useServiceSession,
  q as useServiceSessionFromForm
};
//# sourceMappingURL=useServiceSession.js.map
